exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mp-query-event-selector {\n  display: block;\n}\n:host {\n  display: block;\n}\n.mp-query-event-selector .mp-query-event-selector-row {\n  align-items: center;\n  display: flex;\n}\n.mp-query-event-selector .mp-query-event-selector-row.for-filters {\n  box-sizing: border-box;\n  padding-top: 8px;\n}\n.mp-query-event-selector mp-query-block {\n  flex-shrink: 0;\n  font-size: 14px;\n  margin-right: 8px;\n}\n", ""]);

// exports
